export default __webpack_public_path__ + "static/bluejay-db77d8c52e730eea143987ccc7b56eed.png";